function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "dashboard");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("g", {
  id: "dashboard"
}, /*#__PURE__*/React.createElement("path", {
  d: "M23.5,18H2.5A2.5,2.5,0,0,1,0,15.5V2.5A2.5,2.5,0,0,1,2.5,0h21A2.5,2.5,0,0,1,26,2.5v13A2.5,2.5,0,0,1,23.5,18ZM5,13H21V5H5Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M56.5,35h-21A2.5,2.5,0,0,1,33,32.5V2.5A2.5,2.5,0,0,1,35.5,0h21A2.5,2.5,0,0,1,59,2.5v30A2.5,2.5,0,0,1,56.5,35ZM38,30H54V5H38Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.5,59H2.5A2.5,2.5,0,0,1,0,56.5v-30A2.5,2.5,0,0,1,2.5,24h21A2.5,2.5,0,0,1,26,26.5v30A2.5,2.5,0,0,1,23.5,59ZM5,54H21V29H5Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M56.5,59h-21A2.5,2.5,0,0,1,33,56.5v-13A2.5,2.5,0,0,1,35.5,41h21A2.5,2.5,0,0,1,59,43.5v13A2.5,2.5,0,0,1,56.5,59ZM38,54H54V46H38Z"
}))));

var SvgDashboard = function SvgDashboard(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 59 59",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDashboard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dashboard.b10183c5.svg";
export { ForwardRef as ReactComponent };